import { useState } from 'react';
import { Tabs } from '../ui/Tabs';
type Width = 'telefoon' | 'computer';
const widths: Record<Width, string> = {
  telefoon: 'max-w-[375px]',
  computer: 'max-w-[640px]'
};
type Props = {
  html: string;
  subject: string;
  preheader: string;
  from: string;
};

/**
 * Zo ziet de lezer hem: eerst de regel in haar inbox, dan de mail zelf. De mail staat in een
 * iframe zonder scripts (`sandbox` zonder `allow-scripts`), zodat zijn stijlen het beheer niet raken
 * en andersom. Gebruikt door de nieuwsbrief en Mail › Huisstijl.
 */
export function NewsletterPreview({
  html,
  subject,
  preheader,
  from
}: Props) {
  const [width, setWidth] = useState<Width>('telefoon');
  return <div className="rounded-lg bg-white/60 p-4 ring-1 ring-line sm:p-5" data-id="element-3383" data-mp="3m4k4i8obnnp5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2" data-id="element-3384" data-mp="3m2h8n80hn0ci">
        <h2 className="text-[15px] font-medium text-ink" data-id="element-3385" data-mp="2ydetc6tbtjl6">Voorbeeld</h2>
        <Tabs label="Voorbeeld op" variant="pill" value={width} onChange={setWidth} tabs={[{
        key: 'telefoon',
        label: 'Telefoon'
      }, {
        key: 'computer',
        label: 'Computer'
      }]} data-id="element-3386" data-mp="2tgoc3g5schy6" />
      </div>

      <div className={`mx-auto ${widths[width]}`} data-id="element-3387" data-mp="33ohlj99ff6hs">
        <div className="mb-3 rounded-md border border-line bg-white px-3 py-2.5" aria-label="Zo staat hij in de inbox" data-id="element-3388" data-mp="33ozth35gb95j">
          <p className="truncate text-[13px] font-medium text-ink" data-id="element-3389" data-mp="38p5cjuxnnnc0">{from}</p>
          <p className="truncate text-[13px] text-ink" data-id="element-3390" data-mp="2byv22kj9xlut">{subject || 'Zonder onderwerp'}</p>
          <p className="truncate text-[12px] text-muted" data-id="element-3391" data-mp="2fz5hensyhomc">{preheader || 'De eerste regel van de mail'}</p>
        </div>
        <iframe title="Voorbeeld van de nieuwsbrief" srcDoc={html}
      // Alleen de HTML van de mail, nooit scripts (geen `allow-scripts`). `allow-same-origin` is
      // nodig omdat code van buiten (ontwikkeltools, de preview-omgeving) die frames langsloopt anders
      // een paginafout geeft bij `sessionStorage`. Zonder scripts is die combinatie veilig.
      sandbox="allow-same-origin" className="h-[640px] w-full rounded-md border border-line bg-sand" data-id="element-3392" data-mp="2kzt6v51jdxeg" />
      </div>
    </div>;
}